
import { normalizeModels } from './core'

import models from './data'

export default normalizeModels(models)
